import { render, staticRenderFns } from "./CopyConfigCard.vue?vue&type=template&id=754ece14&"
import script from "./CopyConfigCard.vue?vue&type=script&lang=js&"
export * from "./CopyConfigCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports